// @flow

import React, {Component} from "react";
import type {Item} from "../../../models/Item";
import {getPrice, getRRP} from "../../../models/Item";
import {currencyConverter} from "../../../helper/currency";
import {Link} from "react-router-dom";
import type {translate} from "../../../i18next";
import type {Product} from "../../../models/Product";
import {getHistoricMinimalPrice, getMaxOrderableQuantity, isDiscountedForShippingMethod} from "../../../models/Product";
import "./CartItem.scss";
import classNames from "classnames";
import WarrantyLabel from "../../empco/WarrantyLabel";

export type CartItemProps = {
    t: translate,
    removeFromCart: (Product) => void,
    setQuantity: (string, any) => void,
    cartItem: Item,
    showMsrp: boolean,
    euShop: boolean,
}

class CartItem extends Component<CartItemProps> {
    constructor(props: CartItemProps) {
        super(props);
        this.setQuantity = this.setQuantity.bind(this);
        this.renderPrice = this.renderPrice.bind(this);
    }

    setQuantity(event) {
        this.props.setQuantity(this.props.cartItem.product.id, event.target.value);
    }

    renderPrice() {
        const cartItem = this.props.cartItem;
        const price = getPrice(cartItem);
        const recommendedRetailPrice = getRRP(cartItem);
        const unitPrice = cartItem.product.unitPrice;

        const isSalePrice = isDiscountedForShippingMethod(cartItem.product, cartItem.shippingMethod);
        const historicMinimalPrice = getHistoricMinimalPrice(cartItem.product, cartItem.shippingMethod);

        const historicPriceClass = classNames("", {
            "strikethrough": isSalePrice
        });

        return (
            <div className={"cartItem-price-section"}>
                {recommendedRetailPrice && (
                    <>
                        {this.props.showMsrp && (
                            <div className={"price-row"}>
                                <span>
                                    <span
                                        className={"hpm-price"}>{this.props.t("productDetail.recommendedRetailPrice")}:</span>
                                    <span className={"hpm-price"}>{currencyConverter(recommendedRetailPrice)}</span>
                                </span>
                            </div>
                        )}
                        {historicMinimalPrice && (
                            <div className={"price-row historic-price"}>
                                <span>{this.props.t("productDetail.historicMinimalPurchasePrice")} </span>
                                <span className={historicPriceClass}>{currencyConverter(historicMinimalPrice)}</span>
                            </div>
                        )}
                        <div className={"price-row"}>
                            <span className={"cart-price"}> {currencyConverter(price)}</span>
                        </div>
                    </>
                )}
                {!recommendedRetailPrice && (
                    <div className={"price-row"}>
                        <span className={"cart-price"}>
							{price ? currencyConverter(price) : this.props.t("productDetail.priceOnRequest")}
						</span>
                    </div>
                )}

                {unitPrice && (
                    <div className={"price-row unit-price"}>
                        <small>({currencyConverter(unitPrice.pricePerUnit)} / {unitPrice.measuringUnit === "sqm" ? "m²" : unitPrice.measuringUnit === "cbm" ? "m³" : unitPrice.measuringUnit})</small>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const detailPageURI = `/product/${this.props.cartItem.product.id}/${encodeURIComponent(this.props.cartItem.product.name)}`;
        return (
            <div className="hpm-cartItem">
                {(this.props.cartItem.product.galleryImage && this.props.cartItem.product.galleryImage.previewImage) &&
                    <div className="hpm-cartImage">
                        <Link to={detailPageURI}>
                            <img alt={`Product image: ${this.props.cartItem.product.name}`}
                                 src={this.props.cartItem.product.galleryImage.previewImage.attachmentUrl}/>
                        </Link>
                    </div>
                }
                <div className="hpm-tables">
                    <table className={"hpm-productName"}>
                        <tbody>
                        <tr>
                            <td className="left-section">
                                <Link to={detailPageURI}>
                                    {this.props.cartItem.product.name}
                                </Link>
                                <div>
                                    <span>{this.props.t("cart.productInformation.articleNumberLabel")}:</span> {this.props.cartItem.product.articleNumber}
                                </div>
                                <div>
                                    <span>{this.props.t("cart.productInformation.shippingTypeLabel")}:</span> {this.props.t("cart.productInformation." + this.props.cartItem.shippingMethod)}
                                </div>
                                <WarrantyLabel product={this.props.cartItem.product} euShop={this.props.euShop}
                                               t={this.props.t} variant="compact"/>
                                {this.renderPrice()}
                                {this.props.cartItem.product.isAvailable === false &&
                                    <div className="hpm-cartItem-soldOut">
                                        {this.props.t("cart.productInformation.soldOut")}
                                    </div>
                                }
                            </td>
                            <td className="right-section">
                                <label>{this.props.t("cart.productInformation.amountLabel")}:</label>
                                <select
                                    value={this.props.cartItem.amount}
                                    onChange={this.setQuantity}>
                                    {Array.from(
                                        {length: Math.min(20, getMaxOrderableQuantity(this.props.cartItem.product))},
                                        (_, i) => i + 1
                                    ).map(num => (
                                        <option key={num} value={num}>{num}</option>
                                    ))}
                                </select>
                                <button
                                    type="button"
                                    className="hpm-delete"
                                    onClick={() => this.props.removeFromCart(this.props.cartItem.product)}
                                    onKeyDown={e => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            this.props.removeFromCart(this.props.cartItem.product);
                                        }
                                    }}
                                    aria-label={this.props.t("cart.productInformation.removeFromCart")}
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default CartItem;
